var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow43(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_49589)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_49589)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3995 28.0156C21.716 28.0156 21.189 28.3079 20.8679 28.8408V28.05H19.9209V34.2905H20.8679V31.8321C21.189 32.3651 21.716 32.6573 22.416 32.6573C23.6676 32.6573 24.491 31.7204 24.491 30.3537C24.491 28.9612 23.6429 28.0156 22.3995 28.0156ZM22.2019 31.8149C21.4196 31.8149 20.8679 31.2046 20.8679 30.3193C20.8679 29.4597 21.4196 28.8408 22.2019 28.8408C22.9841 28.8408 23.5359 29.4683 23.5359 30.3193C23.5359 31.196 22.9841 31.8149 22.2019 31.8149Z",
    fill: "#892CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3537 28.0156C25.995 28.0156 25.0645 28.9526 25.0645 30.3365C25.0645 31.7118 25.995 32.6573 27.3537 32.6573C28.7041 32.6573 29.6346 31.7118 29.6346 30.3365C29.6346 28.9526 28.7041 28.0156 27.3537 28.0156ZM27.3537 28.8666C28.1359 28.8666 28.6876 29.4683 28.6876 30.3451C28.6876 31.2304 28.1359 31.8321 27.3537 31.8321C26.5632 31.8321 26.0114 31.2304 26.0114 30.3451C26.0114 29.4683 26.5632 28.8666 27.3537 28.8666Z",
    fill: "#892CA0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8516 26.2441V28.84C33.5304 28.3071 33.0034 28.0063 32.2953 28.0063C31.0601 28.0063 30.2119 28.9432 30.2119 30.3185C30.2119 31.711 31.0518 32.6651 32.3117 32.6651C33.0117 32.6651 33.5386 32.3729 33.8516 31.84V32.6222H34.7985V26.2441H33.8516ZM32.5093 31.84C31.7106 31.84 31.1671 31.2211 31.1589 30.3529C31.1672 29.4761 31.7188 28.8486 32.5093 28.8486C33.2999 28.8486 33.8516 29.4675 33.8516 30.3529C33.8516 31.2211 33.2999 31.84 32.5093 31.84Z",
    fill: "#892CA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9511 28.0156C41.1523 28.0156 40.5677 28.3509 40.2877 29.1159C40.0818 28.4196 39.5466 28.0156 38.7643 28.0156C38.0397 28.0156 37.4797 28.2907 37.1751 28.9354V28.05H36.2363V32.6229H37.1751V30.3623C37.1751 29.5629 37.6362 28.9612 38.3938 28.9354C39.0361 28.9354 39.4231 29.3566 39.4231 30.0528V32.6229H40.3701V30.3623C40.3701 29.5629 40.8229 28.9612 41.5723 28.9354C42.2146 28.9354 42.6098 29.3566 42.6098 30.0528V32.6229H43.5568V29.7778C43.5568 28.6861 42.9557 28.0156 41.9511 28.0156Z",
    fill: "#60605B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3826 32.6229L48.3743 29.623C48.366 28.6173 47.732 28.0156 46.6039 28.0156C45.7722 28.0156 45.3275 28.2133 44.7181 28.5915L45.1052 29.2792C45.5416 28.9698 45.978 28.815 46.398 28.815C47.0897 28.815 47.4438 29.1589 47.4438 29.7348V29.8723H46.118C45.064 29.8809 44.4629 30.4138 44.4629 31.2476C44.4629 32.0556 45.0558 32.6659 46.0027 32.6659C46.6368 32.6659 47.1391 32.4682 47.452 32.0642V32.6229H48.3826ZM46.2004 31.8837C45.6734 31.8837 45.3523 31.6172 45.3523 31.2046C45.3523 30.7663 45.6405 30.5943 46.2581 30.5943H47.4439V31.0155C47.3944 31.5141 46.8757 31.8837 46.2004 31.8837Z",
    fill: "#60605B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2094 28.0156C51.4682 28.0156 50.9083 28.2907 50.5954 28.9268V28.05H49.6484V32.6229H50.5954V30.1903C50.6613 29.4769 51.1142 28.9526 51.8388 28.944C52.4976 28.944 52.8928 29.3652 52.8928 30.0528V32.6229H53.8398V29.7778C53.8398 28.6861 53.2304 28.0156 52.2094 28.0156Z",
    fill: "#60605B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 30.0547H14.7858",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4619 30.6602H15.2487",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4543 31.3394C13.8728 30.3544 14.003 29.4043 13.728 28.0469C13.5771 27.2085 13.0676 26.5164 12.4044 26.2631C11.8573 26.0637 10.721 26.0631 10.2393 26.2631C9.57608 26.5164 9.0666 27.2085 8.91571 28.0469C8.64073 29.4043 8.77098 30.3544 8.18945 31.3394",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4543 31.3394C13.8728 30.3544 14.003 29.4043 13.728 28.0469C13.5771 27.2085 13.0676 26.5164 12.4044 26.2631C11.8573 26.0637 10.721 26.0631 10.2393 26.2631C9.57608 26.5164 9.0666 27.2085 8.91571 28.0469C8.64073 29.4043 8.77098 30.3544 8.18945 31.3394",
    stroke: "black",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8065 29.673C12.9618 29.673 13.0876 29.5346 13.0876 29.3638C13.0876 29.1931 12.9618 29.0547 12.8065 29.0547C12.6513 29.0547 12.5254 29.1931 12.5254 29.3638C12.5254 29.5346 12.6513 29.673 12.8065 29.673Z",
    fill: "#E7E8E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96666 29.673C10.1219 29.673 10.2478 29.5346 10.2478 29.3638C10.2478 29.1931 10.1219 29.0547 9.96666 29.0547C9.81141 29.0547 9.68555 29.1931 9.68555 29.3638C9.68555 29.5346 9.81141 29.673 9.96666 29.673Z",
    fill: "#E7E8E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4549 29.1934L9.41016 29.4858",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.574 29.3633L9.52344 29.9969",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6619 29.5645L9.59668 30.6774",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7065 29.8281L10.1621 30.8133",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4016 29.1934L13.4463 29.4858",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2825 29.3633L13.333 29.9969",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1945 29.5645L13.2598 30.6774",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1509 29.8281L12.6953 30.8133",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4162 30.045C11.9146 30.045 12.3187 29.6436 12.3187 29.1485C12.3187 28.6533 11.9146 28.252 11.4162 28.252C10.9177 28.252 10.5137 28.6533 10.5137 29.1485C10.5137 29.6436 10.9177 30.045 11.4162 30.045Z",
    fill: "white",
    stroke: "#60605B",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7968 28.8472C12.5568 28.8472 12.3622 28.6387 12.3622 28.3816C12.3622 28.1245 12.5568 27.916 12.7968 27.916C13.0369 27.916 13.2314 28.1245 13.2314 28.3816C13.2314 28.6387 13.0369 28.8472 12.7968 28.8472Z",
    fill: "black",
    stroke: "#892CA0",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1873 27.4068C13.1004 27.2888 12.9622 27.2138 12.8199 27.2075C12.6855 27.2015 12.5496 27.2564 12.4541 27.3553",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.416 28.9922L11.4382 29.4559C11.4382 29.4559 11.7933 29.7882 12.0005 29.4482C12.0005 29.4482 11.9782 29.255 11.9635 29.1931",
    stroke: "black",
    strokeWidth: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4126 28.9922L11.3903 29.4559C11.3903 29.4559 11.0353 29.7882 10.8281 29.4482C10.8281 29.4482 10.8503 29.255 10.8651 29.1931",
    stroke: "black",
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8012 28.9867C11.7709 28.9048 11.7709 28.7411 11.6801 28.7411C11.5893 28.7411 11.5053 28.6797 11.416 28.6797C11.3267 28.6797 11.2428 28.7411 11.1519 28.7411C11.0611 28.7411 11.0611 28.9048 11.0309 28.9867C11.0006 29.0685 11.416 29.3345 11.416 29.3345C11.416 29.3345 11.8314 29.0685 11.8012 28.9867Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98443 28.8472C10.2245 28.8472 10.4191 28.6387 10.4191 28.3816C10.4191 28.1245 10.2245 27.916 9.98443 27.916C9.7444 27.916 9.5498 28.1245 9.5498 28.3816C9.5498 28.6387 9.7444 28.8472 9.98443 28.8472Z",
    fill: "black",
    stroke: "#892CA0",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83872 28.4815C9.95676 28.4815 10.0524 28.3777 10.0524 28.2496C10.0524 28.1214 9.95676 28.0176 9.83872 28.0176C9.72069 28.0176 9.625 28.1214 9.625 28.2496C9.625 28.3777 9.72069 28.4815 9.83872 28.4815Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59473 27.4068C9.68157 27.2888 9.81976 27.2138 9.9621 27.2075C10.0965 27.2015 10.2324 27.2564 10.3279 27.3553",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6512 28.4815C12.7693 28.4815 12.8649 28.3777 12.8649 28.2496C12.8649 28.1214 12.7693 28.0176 12.6512 28.0176C12.5332 28.0176 12.4375 28.1214 12.4375 28.2496C12.4375 28.3777 12.5332 28.4815 12.6512 28.4815Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54395 31.3262H15.7567",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1322_49589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 29,
    width: 6,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6792 29.7363H6.91406V32.1731H11.6792V29.7363Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1322_49589)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2181 32.6276C11.1705 32.2891 11.1473 31.921 11.0594 31.4878C10.9628 30.9528 10.6369 30.5112 10.2127 30.3495C9.8627 30.2222 9.13581 30.2219 8.82768 30.3495C8.40345 30.5112 8.07754 30.9528 7.98102 31.4878C7.89307 31.921 7.86992 32.2891 7.82227 32.6276",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2181 32.6276C11.1705 32.2891 11.1473 31.921 11.0594 31.4878C10.9628 30.9528 10.6369 30.5112 10.2127 30.3495C9.8627 30.2222 9.13581 30.2219 8.82768 30.3495C8.40345 30.5112 8.07754 30.9528 7.98102 31.4878C7.89307 31.921 7.86992 32.2891 7.82227 32.6276",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4699 32.5254C10.5692 32.5254 10.6497 32.4371 10.6497 32.3281C10.6497 32.2192 10.5692 32.1309 10.4699 32.1309C10.3705 32.1309 10.29 32.2192 10.29 32.3281C10.29 32.4371 10.3705 32.5254 10.4699 32.5254Z",
    fill: "#E7E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65247 32.5254C8.75179 32.5254 8.83229 32.4371 8.83229 32.3281C8.83229 32.2192 8.75179 32.1309 8.65247 32.1309C8.55316 32.1309 8.47266 32.2192 8.47266 32.3281C8.47266 32.4371 8.55316 32.5254 8.65247 32.5254Z",
    fill: "#E7E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.96515 32.2207L8.29688 32.4073",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04016 32.3301L8.36816 32.7344",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09745 32.457L8.41602 33.1673",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12561 32.625L8.77734 33.2537",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2106 32.2207L10.8789 32.4073",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1356 32.3301L10.8076 32.7344",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0783 32.457L10.7598 33.1673",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0502 32.625L10.3984 33.2537",
    stroke: "#A7A9AC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58122 32.7634C9.90007 32.7634 10.1585 32.5072 10.1585 32.1913C10.1585 31.8753 9.90007 31.6191 9.58122 31.6191C9.26238 31.6191 9.00391 31.8753 9.00391 32.1913C9.00391 32.5072 9.26238 32.7634 9.58122 32.7634Z",
    fill: "white",
    stroke: "#60605B",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4642 31.9985C10.3106 31.9985 10.1862 31.8655 10.1862 31.7014C10.1862 31.5373 10.3106 31.4043 10.4642 31.4043C10.6177 31.4043 10.7422 31.5373 10.7422 31.7014C10.7422 31.8655 10.6177 31.9985 10.4642 31.9985Z",
    fill: "black",
    stroke: "#892CA0",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7131 31.0787C10.6575 31.0034 10.5691 30.9555 10.4781 30.9515C10.3922 30.9476 10.3053 30.9827 10.2441 31.0458",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58008 32.0918L9.59429 32.3877C9.59429 32.3877 9.82143 32.5998 9.95393 32.3828C9.95393 32.3828 9.93972 32.2595 9.93026 32.22",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57795 32.0918L9.56375 32.3877C9.56375 32.3877 9.3366 32.5998 9.2041 32.3828C9.2041 32.3828 9.21831 32.2595 9.22777 32.22",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82775 32.0865C9.80838 32.0343 9.80837 31.9298 9.75029 31.9298C9.6922 31.9298 9.6385 31.8906 9.58137 31.8906C9.52423 31.8906 9.47054 31.9298 9.41245 31.9298C9.35436 31.9298 9.35436 32.0343 9.33499 32.0865C9.31563 32.1388 9.58137 32.3085 9.58137 32.3085C9.58137 32.3085 9.84711 32.1388 9.82775 32.0865Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66474 31.9985C8.81828 31.9985 8.94275 31.8655 8.94275 31.7014C8.94275 31.5373 8.81828 31.4043 8.66474 31.4043C8.51119 31.4043 8.38672 31.5373 8.38672 31.7014C8.38672 31.8655 8.51119 31.9985 8.66474 31.9985Z",
    fill: "black",
    stroke: "#892CA0",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57226 31.7668C8.64777 31.7668 8.70898 31.7005 8.70898 31.6187C8.70898 31.537 8.64777 31.4707 8.57226 31.4707C8.49676 31.4707 8.43555 31.537 8.43555 31.6187C8.43555 31.7005 8.49676 31.7668 8.57226 31.7668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41602 31.0787C8.47164 31.0034 8.56002 30.9555 8.65103 30.9515C8.73697 30.9476 8.82387 30.9827 8.88502 31.0458",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3896 31.7863C10.4652 31.7863 10.5264 31.72 10.5264 31.6383C10.5264 31.5565 10.4652 31.4902 10.3896 31.4902C10.3141 31.4902 10.2529 31.5565 10.2529 31.6383C10.2529 31.72 10.3141 31.7863 10.3896 31.7863Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5585 35.6686L7.33128 33.5574L6.27539 28.7872L9.18591 24.9502L13.8712 24.9355L16.8032 28.7544L15.7739 33.531L11.5585 35.6686Z",
    stroke: "#892CA0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50098 32.2949H11.845",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56445 33.2012H15.5888",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1248 33.0866C15.0738 32.7247 15.0491 32.3311 14.955 31.8681C14.8518 31.2961 14.5034 30.8239 14.0498 30.651C13.6756 30.515 12.8985 30.5146 12.5691 30.651C12.1155 30.8239 11.7671 31.2961 11.6639 31.8681C11.5698 32.3311 11.5451 32.7247 11.4941 33.0866",
    fill: "#CCCCCC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1248 33.0866C15.0738 32.7247 15.0491 32.3311 14.955 31.8681C14.8518 31.2961 14.5034 30.8239 14.0498 30.651C13.6756 30.515 12.8985 30.5146 12.5691 30.651C12.1155 30.8239 11.7671 31.2961 11.6639 31.8681C11.5698 32.3311 11.5451 32.7247 11.4941 33.0866",
    stroke: "black",
    strokeWidth: 3
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3251 32.9785C14.4312 32.9785 14.5173 32.8841 14.5173 32.7676C14.5173 32.6511 14.4312 32.5566 14.3251 32.5566C14.2189 32.5566 14.1328 32.6511 14.1328 32.7676C14.1328 32.8841 14.2189 32.9785 14.3251 32.9785Z",
    fill: "#E7E8E9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3817 32.9785C12.4879 32.9785 12.574 32.8841 12.574 32.7676C12.574 32.6511 12.4879 32.5566 12.3817 32.5566C12.2755 32.5566 12.1895 32.6511 12.1895 32.7676C12.1895 32.8841 12.2755 32.9785 12.3817 32.9785Z",
    fill: "#E7E8E9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7164 32.6504L12.002 32.8499",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7985 32.7656L12.0801 33.198",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0472 32.6504L14.7617 32.8499",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9651 32.7656L14.6836 33.198",
    stroke: "#A7A9AC",
    strokeWidth: 2
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3731 33.2312C13.714 33.2312 13.9903 32.9573 13.9903 32.6195C13.9903 32.2817 13.714 32.0078 13.3731 32.0078C13.0322 32.0078 12.7559 32.2817 12.7559 32.6195C12.7559 32.9573 13.0322 33.2312 13.3731 33.2312Z",
    fill: "white",
    stroke: "#60605B",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.318 32.4146C14.1538 32.4146 14.0208 32.2724 14.0208 32.097C14.0208 31.9215 14.1538 31.7793 14.318 31.7793C14.4822 31.7793 14.6152 31.9215 14.6152 32.097C14.6152 32.2724 14.4822 32.4146 14.318 32.4146Z",
    fill: "black",
    stroke: "#892CA0",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5854 31.4312C14.5259 31.3507 14.4315 31.2996 14.3341 31.2952C14.2423 31.2911 14.1494 31.3286 14.084 31.3961",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M13.373 32.5137L13.3882 32.8301C13.3882 32.8301 13.6311 33.0568 13.7727 32.8248C13.7727 32.8248 13.7576 32.693 13.7474 32.6508",
    stroke: "black",
    strokeWidth: 3
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3704 32.5137L13.3552 32.8301C13.3552 32.8301 13.1124 33.0568 12.9707 32.8248C12.9707 32.8248 12.9859 32.693 12.996 32.6508",
    stroke: "black",
    strokeWidth: 3
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6373 32.5083C13.6166 32.4524 13.6166 32.3407 13.5545 32.3407C13.4924 32.3407 13.4349 32.2988 13.3739 32.2988C13.3128 32.2988 13.2554 32.3407 13.1933 32.3407C13.1312 32.3407 13.1312 32.4524 13.1105 32.5083C13.0898 32.5641 13.3739 32.7456 13.3739 32.7456C13.3739 32.7456 13.658 32.5641 13.6373 32.5083Z",
    fill: "#808080",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3949 32.4146C12.5591 32.4146 12.6921 32.2724 12.6921 32.097C12.6921 31.9215 12.5591 31.7793 12.3949 31.7793C12.2307 31.7793 12.0977 31.9215 12.0977 32.097C12.0977 32.2724 12.2307 32.4146 12.3949 32.4146Z",
    fill: "black",
    stroke: "#892CA0",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2946 32.1642C12.3753 32.1642 12.4408 32.0933 12.4408 32.0059C12.4408 31.9185 12.3753 31.8477 12.2946 31.8477C12.2139 31.8477 12.1484 31.9185 12.1484 32.0059C12.1484 32.0933 12.2139 32.1642 12.2946 32.1642Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1279 31.4312C12.1874 31.3507 12.2819 31.2996 12.3792 31.2952C12.4711 31.2911 12.564 31.3286 12.6293 31.3961",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "square"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2497 32.1857C14.3304 32.1857 14.3959 32.1148 14.3959 32.0274C14.3959 31.94 14.3304 31.8691 14.2497 31.8691C14.169 31.8691 14.1035 31.94 14.1035 32.0274C14.1035 32.1148 14.169 32.1857 14.2497 32.1857Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10156 33.8066H11.8883",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7246 34.4102H13.0196",
    stroke: "#3C6EB4",
    strokeWidth: 4
  })))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_49589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_49589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 14,
    fill: "white",
    transform: "translate(5 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow43);
export default __webpack_public_path__ + "static/media/row-4-3.bc7a37d76489d7158f20a3f011496ceb.svg";
export { ForwardRef as ReactComponent };